import { api } from '../../services/api'

const state = () => ({
  items: [],
  current: null,
  loading: false,
  error: null
})

const getters = {
  all: (s) => s.items
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_CURRENT(state, item) {
    state.current = item
  },
  ADD_ITEM(state, item) {
    state.items.unshift(item)
  },
  UPDATE_ITEM(state, item) {
    const i = state.items.findIndex((x) => String(x.id) === String(item.id))
    if (i !== -1) state.items.splice(i, 1, item)
  },
  REMOVE_ITEM(state, id) {
    state.items = state.items.filter((x) => String(x.id) !== String(id))
  },
  SET_LOADING(state, v) {
    state.loading = v
  },
  SET_ERROR(state, e) {
    state.error = e
  }
}

const actions = {
  async list({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await api.get('admin/account-sheets')
      commit('SET_ITEMS', Array.isArray(data) ? data : data?.items || [])
      commit('SET_ERROR', null)
    } catch (e) {
      commit('SET_ERROR', e.message || 'Failed to load account sheets')
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async fetchOne({ commit }, id) {
    const { data } = await api.get(`admin/account-sheets/${id}`)
    commit('SET_CURRENT', data)
    return data
  },
  async create({ commit }, payload) {
    const { data } = await api.post('admin/account-sheets', payload)
    commit('ADD_ITEM', data)
    return data
  },
  async update({ commit }, { id, payload }) {
    const { data } = await api.put(`admin/account-sheets/${id}`, payload)
    commit('UPDATE_ITEM', data)
    return data
  },
  async remove({ commit }, id) {
    await api.delete(`admin/account-sheets/${id}`)
    commit('REMOVE_ITEM', id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
